import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@src/query';
import { getGroupMentionPages } from './api';
import { useAuthEnabled } from '@src/hooks/useAuthStatus';

/**
 * Get mention pages for user's group
 */
export const useQueryGroupMentionPages = () => {
  const authEnabled = useAuthEnabled();

  return useQuery({
    queryKey: QUERY_KEYS.userGroupMentionPages(),
    queryFn: () => getGroupMentionPages(),
    staleTime: Infinity,
    gcTime: Infinity,
    enabled: authEnabled,
  });
};
